import { IUserInfo } from 'app/modules/contract/model/userInfo.model';
import axios, { AxiosResponse } from 'axios';
import { ISellingPointInfoBanking } from '../model/selling-point.model';

export interface ISellingPointApi {
  getSellingPointSubscriber(clientNumber): Promise<AxiosResponse<any>>;
}

export class ClassSellingPointApi implements ISellingPointApi {
  async getSellingPointSubscriber(clientNumber): Promise<AxiosResponse<any>> {
    const user = axios.get('api/user/getSellingPointSubscriber' + clientNumber);
    return user;
  }

  async updateSellingPointSubscriber(userInfo: IUserInfo): Promise<AxiosResponse<any>> {
    return axios.put('api/subscriber/updateSubscriber',{actor :userInfo,subscriptionNumber:""});
  }
  async updateSellingPointInfoBank(sellingPointInfoBanking: ISellingPointInfoBanking): Promise<AxiosResponse<any>> {
    return axios.post('api/sellingPoint/update', sellingPointInfoBanking);
  }
  async getSellingPoint(): Promise<AxiosResponse<any>> {
    return axios.post('api/sellingPoint/findDetail');
  }
}
